import "./PartsCatalogue.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import ShopTitle from "./sections/ShopTitle";
import ShopContent from "./sections/ShopContent";
import Partsinquirycontact from "./sections/Partsinquirycontact";
import CorporateInformationFooter from "@/reusable_sections/Footer";
export default function PartsCataloguePage() {
  return <div>
      <MainNavigationHeader />
      <ShopTitle />
      <ShopContent />
      <Partsinquirycontact />
      <CorporateInformationFooter />
    </div>;
}